import React, { Component } from 'react'
import { MuiGrid, MuiDialog, MuiDialogContent, MuiTextField, MuiEdit, MuiButton, MuiIconButton, MuiClear, MuiTypography } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import spinner from "../../../ui/icons/spinner.gif"
import AlertDialogComponent from '../teacher/AlertDialogComponent';
import { gradePickerUtil } from '../../gradePicker';
import lodashUtil from 'lodash';
import { toast } from 'react-toastify';

export class GradeList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggleChange: false,
      showDeleteConfirmDialog: false,
      errorMessage: undefined,
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  displayDialog = () => {
    this.setState({ open: true })
  }

  onChange = (name, event) => {
    let index = this.props.index
    this.props.grade[name] = event.target.value
    if (name === "gradeName" && this.props.grade.groups !== undefined) {
      let groups = this.props.calculateGroupsAndRoomName(this.props.grade.numberOfGroups, event.target.value)
      this.props.grade.groups = groups
    }
    this.props.updateData()
    this.setState({
      toggleChange: !this.state.toggleChange,
    })
  }

  onChangeGroupNumber = (event) => {
    let currentGrade = JSON.parse(JSON.stringify(this.props.grade))
    const i18n = this.props.i18n
    let gradeName = this.props.grade.gradeName;
    let groups = this.props.calculateGroupsAndRoomName(event.target.value, gradeName)

    let differenceInGroupsIfReduced = lodashUtil.differenceBy(this.props.grade.groups, groups, "groupName");
    if (differenceInGroupsIfReduced.length > 0) {
      this.props.whenNumberOfGroupsReduced(gradeName, differenceInGroupsIfReduced)
    }

    let differenceInGroupsIfadded = lodashUtil.differenceBy(groups, this.props.grade.groups, "groupName");
    if (differenceInGroupsIfadded.length > 0) {
      this.props.whenNumberOfGroupsAdded(gradeName, differenceInGroupsIfadded);
    }

    this.props.grade.numberOfGroups = event.target.value
    this.props.grade.groups = groups
    // this.props.modifyingSubjectArray(groups, gradeName);
    // this.props.modifyingElectiveArray(groups, gradeName);
    // this.props.modifyingTeacherArray(groups, gradeName);
    if (!this.props.checkSubscriptionOnEdit(this.props)) {
      this.props.grade.numberOfGroups = currentGrade.numberOfGroups
      this.props.grade.groups = currentGrade.groups;
      toast(i18n.grades.maxNumberOfGroupsExceedError)
    }
    this.props.modifyingSubjectArray(this.props.grade.groups, this.props.grade.gradeName);
    this.props.modifyingElectiveArray(this.props.grade.groups, this.props.grade.gradeName);
    this.props.modifyingTeacherArray(this.props.grade.groups, this.props.grade.gradeName);
    this.setState({ toggleChange: !this.state.toggleChange, })
  }

  onChangeOfGroupIds = (name, event, indexOfGroupId) => {
    let groupNames = this.props.gradeMasterData.grades.slice(0, Number(event.target.value))
    let indexOfGrade = this.props.index
    this.props.grade.groups[indexOfGroupId].groupName = event.target.value
    this.setState({
      toggleChange: !this.state.toggleChange
    })
  }


  onChangeOfHomeRooms = (name, event, indexOfGroupId) => {

    let indexOfGrade = this.props.index
    this.props.grade.groups[indexOfGroupId].roomName = event.target.value
    this.setState({
      toggleChange: !this.state.toggleChange
    })
  }

  handleCloseDialog = () => {
    this.setState({ showDeleteConfirmDialog: false });
  }

  onClickOfDeleteGrade = () => {
    let errorMessage = "";
    let isGradePresentValidation = false;
    let subjectsList = this.props.activeSchool.school_master.subjects;
    let gradeObj = this.props.grade
    let gradeDetails = {
      allGrades: false,
      gradeLevels: [],
      grades: [
        {
          grade: gradeObj.gradeName,
          groups: []
        }
      ]
    }
    const i18n = this.props.i18n
    if (subjectsList != undefined && subjectsList.length != 0) {
      let gradeLowestForm = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, this.props)
      for (let i = 0; i < subjectsList.length; i++) {
        let subjectObj = subjectsList[i];
        let subjectGradeDetailLowestForm = gradePickerUtil.convertingGradeDetailsToLowestFormat(subjectObj.gradeDetails, this.props)
        let isGradePresentInSubject = lodashUtil.difference(gradeLowestForm, subjectGradeDetailLowestForm)
        if (isGradePresentInSubject.length !== gradeLowestForm.length) {
          errorMessage = i18n.grades.relatedInfoDeletingMsg
          isGradePresentValidation = true

          this.setState({
            showDeleteConfirmDialog: true,
            errorMessage: errorMessage
          });
          break;
        }
      }
    }
    if (isGradePresentValidation === false) {
      // errorMessage = i18n.grades.deletingGrade
      this.handeleDeleteGrade();
    }

    // this.setState({
    //   showDeleteConfirmDialog: true,
    //   errorMessage: errorMessage
    // });
  }

  handeleDeleteGrade = () => {
    let key = this.props.index
    this.props.updateData()
    this.props.removeGradeFromGradeList(key)
    this.setState({ showDeleteConfirmDialog: false });

  }

  render() {
    const { gradeNumber, gradeLevel, numberOfGroups, grades } = this.props.gradeMasterData
    const { i18n } = this.props
    if (this.props.gradeMasterData.gradeLevel == undefined) {
      return <img src={spinner} alt="none" style={theme.spinnerImgStyle} />
    }
    return (
      <div>
        <MuiDialog
          open={this.state.open}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          scroll='paper'
          maxWidth='lg'
        >
          <MuiDialogContent>
            <MuiGrid container xs={12} style={{ border: '1px solid', borderColor: theme.palette.primary.main }}>
              <MuiGrid container xs={12} >
                <MuiGrid item xs={6} style={{ borderRight: "1px solid " + theme.palette.primary.main }}>
                  <MuiGrid container xs={12} variant={theme.typographyStyles.BODY1} style={{ padding: 16.5 }}  >
                    <MuiGrid item xs={12} > <MuiTypography variant="button"><b>{i18n.grades.groupId}</b></MuiTypography></MuiGrid>
                    <MuiGrid item xs={12} ><MuiTypography variant="caption">{undefined}</MuiTypography>
                    </MuiGrid></MuiGrid>

                  {this.props.grade.groups.map((group, index) =>
                    <MuiGrid item xs={12}
                      style={{ padding: 6, borderRight: index + 1 != this.props.grade.groups.length, borderTop: "1px solid " + theme.palette.primary.main }}>
                      <MuiTextField
                        id="group"
                        disabled={true}
                        value={group.groupName}
                        onChange={(event) => this.onChangeOfGroupIds('groupId', event, index)}></MuiTextField></MuiGrid>)}
                </MuiGrid>
                <MuiGrid item xs={6} style={{}}>

                  <MuiGrid container xs={12} variant={theme.typographyStyles.BODY1} style={{ padding: 6 }}  >

                    <MuiGrid item xs={12}> <MuiTypography variant="button"> <b>{i18n.grades.homeRoom}</b></MuiTypography></MuiGrid>
                    <MuiGrid item xs={12} ><MuiTypography variant="caption"><i>{i18n.commonTexts.optional}</i></MuiTypography></MuiGrid>
                  </MuiGrid>
                  {this.props.grade.groups.map((group, index) =>
                    <MuiGrid item xs={12}
                      style={{ padding: 6, borderRight: index + 1 != this.props.grade.groups.length, borderTop: "1px solid " + theme.palette.primary.main }}>
                      <MuiTextField
                        id="room"
                        value={group.roomName}
                        onChange={(event) => this.onChangeOfHomeRooms('homeRooms', event, index)}
                      ></MuiTextField></MuiGrid>)}
                </MuiGrid>
              </MuiGrid>
            </MuiGrid>
            <br />
            <MuiGrid container xs alignItems="flex-end" justify="flex-end" spacing={9}>
              <MuiGrid item xs={1} align='left' >
                <MuiButton style={theme.secondaryButtonStyle} onClick={this.handleClose} id="cancel">
                  {i18n.commonTexts.cancel}
                </MuiButton>
              </MuiGrid>
              <MuiGrid item xs={1} align='right'>
                <MuiButton style={theme.primaryButtonStyle} onClick={this.handleClose} id="save">
                  {i18n.commonTexts.apply}
                </MuiButton>
              </MuiGrid>
            </MuiGrid>
          </MuiDialogContent>
        </MuiDialog>
        < MuiGrid container xs={12} >
          {this.props.getGradesInProgress == true && this.props.getGradeMasterDataInProgress == true && (
            <img
              src={spinner}
              alt="none"
              style={{ textDecoration: "none" }}
            />
          )}
          < MuiGrid item xs={2} style={theme.gridTableSelectStyle} alignItems='center'>
            < MuiTextField
              id="gradeLevel"
              variant="standard"
              style={{ width: "100%", height: "100%" }}
              select
              value={this.props.grade.levelName}
              onChange={(event) => this.onChange('levelName', event)}
              SelectProps={{
                native: true, disableUnderline: true
              }} >
              <option style={{ display: 'none' }}>
              </option>
              {gradeLevel.map((grade) => <option
                value={grade}>{grade}</option>)}}
             </ MuiTextField>
          </ MuiGrid>
          < MuiGrid item xs={2} style={theme.gridTableSelectStyle} align='center'>
            < MuiTextField
              select
              id="gradeNumber"
              variant="standard"
              style={{ width: "100%", height: "100%" }}
              value={this.props.grade.gradeName}
              onChange={(event) => this.onChange('gradeName', event)}
              SelectProps={{
                native: true, disableUnderline: true
              }}
            >
              <option
                style={{
                  display: 'none',
                  height: "6vh"
                }}>
              </option>
              {gradeNumber.map((grade) => <option
                value={grade}>{grade}</option>)}
            </ MuiTextField>
          </ MuiGrid>
          < MuiGrid item xs={2} style={theme.gridTableSelectStyle} align='center'>
            < MuiTextField
              id="numberOfGroups"
              variant="standard"
              style={{ width: "100%", height: "100%" }}
              select
              value={this.props.grade.numberOfGroups}
              onChange={(event) => this.onChangeGroupNumber(event)}
              SelectProps={{
                native: true, disableUnderline: true
              }}
            >
              <option style={{ display: 'none', height: "6vh" }}></option>
              {numberOfGroups.map((grade) => <option value={grade}>{grade}
              </option>)}
            </ MuiTextField>
          </ MuiGrid>


          < MuiGrid container direction="row" xs alignItems='center' style={theme.gridTableBeforeEditStyle} >
            {this.props.grade.groups.map((group, index) =>

              <span>&nbsp;{group.groupName}{index + 1 != this.props.grade.groups.length ? "," : null}&nbsp;</span>
            )}
          </ MuiGrid>


          < MuiGrid item style={theme.gridTableEditStyle} align='right' >
            <MuiIconButton onClick={() => this.displayDialog()} >
              < MuiEdit id="editButton" style={{ color: theme.palette.grey.dark }} />
            </MuiIconButton>
          </MuiGrid>
          {this.state.showDeleteConfirmDialog &&
            <AlertDialogComponent
              {...this.props}
              errorMessage={this.state.errorMessage}
              openDialog={this.state.showDeleteConfirmDialog}
              handleCloseDialog={this.handleCloseDialog}
              handleClickOnYes={this.handeleDeleteGrade}

            />
          }

          < MuiGrid item style={theme.gridTableClearButtonStyle} >
            <MuiIconButton onClick={() => this.onClickOfDeleteGrade()} id="delete">
              <MuiClear style={{ color: theme.palette.grey.dark }} />
            </MuiIconButton>
          </ MuiGrid>
        </ MuiGrid>
      </div>
    )
  }
}

export default GradeList
